// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div:has(> app-alerta):has(> app-button) {
  display: flex;
  flex-direction: column;
}
div:has(> app-alerta):has(> app-button) app-button {
  align-self: flex-end;
}

.iconos-centrados {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
}

.contenedor-radio {
  gap: 1rem;
}

div.resumen label {
  font-weight: bold;
}
div.resumen p {
  margin-bottom: 0;
}
div.resumen p > a {
  color: var(--primary);
  cursor: pointer;
}

i.text-warning {
  color: #ffc107 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/expedientes-detalle/expedientes-detalle.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;AACJ;AAAI;EACI,oBAAA;AAER;;AACA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;AAEF;;AAAA;EACE,SAAA;AAGF;;AAAE;EACE,iBAAA;AAGJ;AADE;EACE,gBAAA;AAGJ;AAFI;EACE,qBAAA;EACA,eAAA;AAIN;;AAAA;EACE,yBAAA;AAGF","sourcesContent":["div:has(> app-alerta):has(> app-button) {\n    display: flex;\n    flex-direction: column;\n    & app-button {\n        align-self: flex-end;\n    }\n}\n.iconos-centrados {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 0.5rem; // Espacio entre los íconos\n}\n.contenedor-radio {\n  gap: 1rem;\n}\ndiv.resumen {\n  label {\n    font-weight: bold;\n  }\n  p {\n    margin-bottom: 0;\n    > a {\n      color: var(--primary);\n      cursor: pointer;\n    }\n  }\n}\ni.text-warning {\n  color: #ffc107!important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
